import React from "react";
import i18next from "i18next";

export default function useChangeLanguage(): (lang: string) => void {
    return React.useCallback(lang => i18next.changeLanguage(lang), []);
}
